import { useTranslation } from 'next-i18next'

import Input from '~/bootcamp/Activities/components/Input'

export default function CarriedNumbersExpression({
  carriedNumbers,
  gridCols,
  onCarriedNumbersChange,
}: {
  carriedNumbers: Record<string, string>
  gridCols: number
  onCarriedNumbersChange: (value: string, name: string) => void
}): React.ReactElement {
  const { t } = useTranslation('generics')
  const commonGridStyle = {
    display: 'grid',
    gridTemplateColumns: `repeat(${gridCols}, minmax(0, 1fr))`,
  }

  return (
    <div className="self-end" style={commonGridStyle}>
      {Object.entries(carriedNumbers).map(([key, value]) => (
        <span className="w-8 sm:w-10 flex justify-center" key={key}>
          <Input
            aria-label={t('ariaLabelButtons.insertCarriedNumber')}
            isSmall
            maxDigits={1}
            name={key}
            onChange={onCarriedNumbersChange}
            value={value}
          />
        </span>
      ))}
    </div>
  )
}
